import { queryOptions } from '@tanstack/react-query'
import { getAccounts } from '@/src/services/user'

export const userAccountsQuery = ({ enabled }: { enabled?: boolean } = {}) =>
  queryOptions({
    queryKey: ['user', 'accounts'],
    queryFn: () => getAccounts(),
    enabled,
  })
